const DAY = 86_400_000
const tz = 'Africa/Lagos'

const compact = new Intl.NumberFormat('en-NG', { notation: 'compact', maximumFractionDigits: 1 })
const whole = new Intl.NumberFormat('en-NG', { maximumFractionDigits: 1 })
const money = new Intl.NumberFormat('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const nairaShort = (kobo: number) => `₦${compact.format(kobo / 100)}`
export const nairaFull = (kobo: number) => `₦${money.format(kobo / 100)}`
export const naira = (n: number) => `₦${whole.format(n)}`
export const short = (n: number) => compact.format(n)
export const num = (n: number) => whole.format(n)
export const kg = (n: number) => `${whole.format(n)}kg`

const time = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: tz })
const date = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: '2-digit', timeZone: tz })
const long = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: tz })
const dayKey = (t: number) => new Intl.DateTimeFormat('en-CA', { timeZone: tz }).format(t)

// "Today, 19:40" · "Yesterday" · "19 Aug 22" — the table format in the designs.
export function orderDate(t: number | null | undefined) {
  if (!t) return '—'
  const now = Date.now()
  if (dayKey(t) === dayKey(now)) return `Today, ${time.format(t)}`
  if (dayKey(t) === dayKey(now - DAY)) return 'Yesterday'
  return date.format(t)
}

const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
// "3 weeks ago" · "last month" · "Sep 26, 2022" — the activity feed format in the designs.
export function ago(t: number) {
  const diff = t - Date.now()
  const abs = Math.abs(diff)
  if (abs < 60_000) return 'just now'
  if (abs < 3_600_000) return rtf.format(Math.round(diff / 60_000), 'minute')
  if (abs < DAY) return rtf.format(Math.round(diff / 3_600_000), 'hour')
  if (abs < 7 * DAY) return rtf.format(Math.round(diff / DAY), 'day')
  if (abs < 30 * DAY) return rtf.format(Math.round(diff / (7 * DAY)), 'week')
  if (abs < 60 * DAY) return rtf.format(-1, 'month')
  return long.format(t)
}

export const pct = (n: number) => `${n > 0 ? '+' : ''}${n.toFixed(2)}%`
export const initials = (name: string) => name.split(/\s+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase()
export const fileUrl = (key: string | null | undefined) => (key ? `/api/files/${key}` : null)
